export const getVehicleData = async (reg) => {
  const res = await fetch(`/.netlify/functions/uk-vehicle-data?reg=${reg}`)
  const data = await res.json()

  return data
}
